module.exports = __webpack_public_path__ + "static/media/fish-tiktok-2.488d48c4.jpg";